import { RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Events/hooks/useEventType.ts
/**
* Get a single EventType details
* @param args
* @param opts
*/
function useEventType(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Events.GetEventTypeDetail.v1, args || void 0, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useEventType };

//# sourceMappingURL=useEventType.js.map